'use client';
import { useMemo } from 'react';
import { useHoveredContext, useSelectedContext } from '../../context';

const useFilterActive = (items: any) => {
  const isHovered = useHoveredContext();
  const isSelected = useSelectedContext();

  return useMemo(
    () => items.filter((d: any) => isHovered(d.id) || isSelected(d.id)),
    [items, isHovered, isSelected],
  );
};

export default useFilterActive;
